import React, { useState, useEffect } from 'react';
import { X, ChevronRight, ChevronLeft, Check } from 'lucide-react';

const TutorialOverlay = ({ isOpen, onClose }) => {
  // 1. PRIMERO: Todos los Hooks siempre arriba
  const [step, setStep] = useState(0);

  // Reiniciar el paso a 0 cada vez que el tutorial se abre
  useEffect(() => {
    if (isOpen) {
      setStep(0);
    }
  }, [isOpen]);

  // 2. SEGUNDO: El return condicional (después de los hooks)
  if (!isOpen) return null;

  // 3. TERCERO: Lógica y constantes
  const tutorialSteps = [
    {
      title: "¡Bienvenido a la app EducaT Mexico!",
      image: "/tutorial/paso1.png",
      description: "Aprende gramática y vocabulario antes de cada reto."
    },
    {
      title: "¡Vamos a comenzar!",
      image: "/tutorial/paso5.png",
      description: "Visualiza todos los retos y aprende."
    },
    {
      title: "Domina el Quiz",
      image: "/tutorial/paso2.png",
      description: "Mantén tus vidas altas para ganar más XP y racha."
    },
    {
      title: "Personaliza tu aventura",
      image: "/tutorial/paso3.png",
      description: "Usa tus puntos en la tienda para comprar nuevas skins."
    },
    {
      title: "Disfruta y aprende",
      image: "/tutorial/paso4.png",
      description: "Bienvenido a una experiencia de aprendizaje divertida y efectiva."
    }
  ];

  const handleClose = () => {
    localStorage.setItem('tutorial_visto_v1', 'true');
    onClose(); 
  };

  const nextStep = () => {
    if (step < tutorialSteps.length - 1) setStep(step + 1);
    else handleClose();
  };

  const prevStep = () => {
    if (step > 0) setStep(step - 1);
  };

  // 4. CUARTO: El JSX
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/80 backdrop-blur-sm p-4 animate-in fade-in duration-300">
      <div className="bg-white w-full max-w-lg rounded-3xl overflow-hidden shadow-2xl flex flex-col relative animate-in zoom-in-95 duration-300">
        
        {/* BOTÓN CERRAR */}
        <button 
          onClick={handleClose}
          className="absolute top-4 right-4 z-10 p-2 bg-slate-100 hover:bg-slate-200 rounded-full text-slate-500 transition-colors"
        >
          <X size={20} />
        </button>

        {/* CONTENIDO DEL PASO */}
        <div className="flex-1 flex flex-col">
          <div className="relative aspect-[4/3] bg-slate-100">
            <img 
              src={tutorialSteps[step].image} 
              alt={tutorialSteps[step].title}
              className="w-full h-full object-contain"
            />
          </div>

          <div className="p-6 text-center space-y-2">
            <h3 className="text-xl font-black text-slate-800 uppercase tracking-tight">
              {tutorialSteps[step].title}
            </h3>
            <p className="text-slate-500 text-sm leading-relaxed">
              {tutorialSteps[step].description}
            </p>
          </div>
        </div>

        {/* NAVEGACIÓN INFERIOR */}
        <div className="p-6 pt-0 flex items-center justify-between">
          <div className="flex gap-1.5">
            {tutorialSteps.map((_, i) => (
              <div 
                key={i} 
                className={`h-2 rounded-full transition-all duration-300 ${i === step ? 'w-6 bg-indigo-600' : 'w-2 bg-slate-200'}`}
              />
            ))}
          </div>

          <div className="flex gap-3">
            {step > 0 && (
              <button 
                onClick={prevStep}
                className="p-3 rounded-2xl bg-slate-100 text-slate-600 font-bold hover:bg-slate-200 transition-all active:scale-95"
              >
                <ChevronLeft size={24} />
              </button>
            )}

            <button 
              onClick={nextStep}
              className="flex items-center gap-2 px-6 py-3 rounded-2xl bg-indigo-600 text-white font-bold hover:bg-indigo-700 shadow-lg shadow-indigo-200 transition-all active:scale-95"
            >
              {step === tutorialSteps.length - 1 ? (
                <>EMPEZAR <Check size={20} /></>
              ) : (
                <>SIGUIENTE <ChevronRight size={20} /></>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TutorialOverlay;